export default function MainContent({ children }) {
  return <main className="main">{children}</main>;
}